import { axios } from '../../../lib/axios';
import type { SurveyDto, SurveyFormulaQuestionResponseDto, SurveyQuestionAnswerResponseDto } from '../types';

const BASE_URL = '/api/surveys'

export const getSurveyById = async (surveyId: string): Promise<SurveyDto> => {
    const response = await axios.get(`${BASE_URL}/${surveyId}`) as SurveyDto;
    return response;
};

export const saveQuestion = async (body: SurveyQuestionAnswerResponseDto): Promise<SurveyFormulaQuestionResponseDto[]> => {
    const response = await axios.post(`${BASE_URL}/`, body) as SurveyFormulaQuestionResponseDto[];
    return response;
}

export const setSurveyAsFinish = async (surveyParticipantId: string) => {
    const response = await axios.post(`${BASE_URL}/${surveyParticipantId}/finish`);
    return response;
}
